export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SinisterDetail.vue?vue&type=template&id=3412c8ea"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Reports/BudgetReport/SinisterDetail.vue?vue&type=template&id=3412c8ea
// module id = 2204
// module chunks = 31